import { render, staticRenderFns } from "./Settrc.vue?vue&type=template&id=32f86846&scoped=true"
import script from "./Settrc.vue?vue&type=script&lang=js"
export * from "./Settrc.vue?vue&type=script&lang=js"
import style0 from "./Settrc.vue?vue&type=style&index=0&id=32f86846&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f86846",
  null
  
)

export default component.exports